import SpriteSymbol from "../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check-solid",
  "use": "check-solid-usage",
  "viewBox": "0 0 12 9",
  "content": "<symbol viewBox=\"0 0 12 9\" xmlns=\"http://www.w3.org/2000/svg\" id=\"check-solid\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.226 1.6875L4.81579 8.45378L0.774048 4.1875L2.22595 2.81201L4.81579 5.54573L9.77405 0.312012L11.226 1.6875Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol